/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BuildingGovIcon16Light } from './BuildingGovIcon16Light';
import { BuildingGovIcon16Regular } from './BuildingGovIcon16Regular';
import { BuildingGovIcon16Solid } from './BuildingGovIcon16Solid';
import { BuildingGovIcon20Light } from './BuildingGovIcon20Light';
import { BuildingGovIcon20Regular } from './BuildingGovIcon20Regular';
import { BuildingGovIcon20Solid } from './BuildingGovIcon20Solid';
import { BuildingGovIcon24Regular } from './BuildingGovIcon24Regular';
import { BuildingGovIcon24Solid } from './BuildingGovIcon24Solid';
import { BuildingGovIcon32Regular } from './BuildingGovIcon32Regular';
import { BuildingGovIcon64Regular } from './BuildingGovIcon64Regular';
var sizes = {
    16: {
        light: BuildingGovIcon16Light,
        regular: BuildingGovIcon16Regular,
        solid: BuildingGovIcon16Solid,
    },
    20: {
        light: BuildingGovIcon20Light,
        regular: BuildingGovIcon20Regular,
        solid: BuildingGovIcon20Solid,
    },
    24: {
        regular: BuildingGovIcon24Regular,
        solid: BuildingGovIcon24Solid,
    },
    32: {
        regular: BuildingGovIcon32Regular,
    },
    64: {
        regular: BuildingGovIcon64Regular,
    },
};
export var BuildingGovIcon = forwardRef('BuildingGovIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
